import SparePartsContainer from './SparePartsContainer';

export default SparePartsContainer;
